import getUpdatedDataReduxUtil from '../../../modules/redux/utils/get-updated-data'
import isInstanceReduxUtil from '../../../modules/redux/utils/is-instance'
import { logUtil } from 'packages/src'
import getStringifiedPropertiesObjectUtil from '../../object/get-stringified-properties'

export default function getDataAnalyticsAction (instanceOrData = {}) {
  let data
  if (typeof instanceOrData === 'string') {
    logUtil('getDataAnalyticsAction').debug('[invalid_type] string, instanceOrData should be an object: ', instanceOrData)
    instanceOrData = {
      value: instanceOrData
    }
  }
  if (Array.isArray(instanceOrData)) {
    logUtil('getDataAnalyticsAction').debug('[invalid_type] array, instanceOrData should be an object or array: ', instanceOrData)
    instanceOrData = {
      value: instanceOrData
    }
  }
  if (isInstanceReduxUtil(instanceOrData)) {
    data = getUpdatedDataReduxUtil(instanceOrData)
  } else {
    data = instanceOrData
  }
  return getStringifiedPropertiesObjectUtil(data)
}
